import { useEffect, useState } from "react";
import { navItems, siteName } from "@/mocks/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a href="#top" className="flex items-center gap-2 cursor-pointer">
            <span
              className={`service-icon-wrap rounded-md flex items-center justify-center transition-colors ${
                solid ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
              }`}
            >
              <i className="ri-book-2-line text-lg"></i>
            </span>
            <span
              className={`font-heading font-semibold tracking-wide text-base md:text-lg ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              {siteName}
            </span>
          </a>

          <ul className="hidden lg:flex items-center gap-7">
            {navItems.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  className={`text-sm whitespace-nowrap transition-colors cursor-pointer ${
                    solid
                      ? "text-foreground-700 hover:text-primary-600"
                      : "text-background-100 hover:text-accent-300"
                  }`}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2">
            <a
              href="#ending"
              className="hidden md:inline-flex items-center gap-1 px-4 py-2 rounded-md text-sm whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              直击大结局 <i className="ri-arrow-right-line"></i>
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="切换菜单"
              aria-expanded={open}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
                solid ? "text-foreground-900" : "text-background-50"
              }`}
            >
              <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
            </button>
          </div>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 animate-fade-in-down">
          <ul className="px-4 py-2 flex flex-col">
            {navItems.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  onClick={() => setOpen(false)}
                  className="block py-3 text-sm text-foreground-800 border-b border-background-100 cursor-pointer"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="pt-3 pb-2">
              <a
                href="#ending"
                onClick={() => setOpen(false)}
                className="inline-flex items-center gap-1 px-4 py-2.5 rounded-md text-sm bg-primary-500 text-background-50 cursor-pointer"
              >
                直击大结局 <i className="ri-arrow-right-line"></i>
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}